// Web stub for @stripe/stripe-react-native
export const useStripe = () => {
  return {
    initPaymentSheet: async (params: any) => ({ error: null }),
    presentPaymentSheet: async () => ({ error: null }),
    createPaymentMethod: async (params: any) => ({ paymentMethod: null, error: null }),
    confirmPaymentSheetPayment: async () => ({ error: null }),
    handleURLCallback: async (url: string) => true,
    retrievePaymentIntent: async (clientSecret: string) => ({ paymentIntent: null, error: null }),
    confirmPayment: async (clientSecret: string, options: any) => ({ error: null }),
  };
};

export const StripeProvider = (props: any) => {
  return <>{props.children}</>;
};

export default {
  useStripe,
  StripeProvider,
};
